/* Disco Chores — gift card artwork.
   Draws the little scene on each gift card from its data-kind / data-tint.
   Upload alongside dc-motion.js and dc-demo.js. */
(function(){
  const TINTS = {
    lilac:{name:"Lilac",hex:"#C0A8DE"},
    mint:{name:"Mint",hex:"#BCE6D3"},
    powder:{name:"Powder",hex:"#BECFE8"},
    bubblegum:{name:"Bubblegum",hex:"#F2B8D8"},
    orchid:{name:"Orchid",hex:"#C57FD0"},
    peri:{name:"Periwinkle",hex:"#85A3E0"}
  };


  function giftScene(kind, tint){
    const c = TINTS[tint].hex;
    const S = 'stroke="var(--ink)" fill="none" stroke-width="2.2"';
    const bg = '<rect width="240" height="320" fill="'+c+'" opacity=".2"/>';
    const art = {
      // framed print on a wall, with a hook
      wall: '<path d="M120 40 v18" '+S+'/><rect x="52" y="58" width="136" height="176" rx="4" fill="#FFF" '+S+'/>'
        + '<rect x="66" y="72" width="108" height="148" fill="'+c+'" opacity=".55"/>'
        + '<circle cx="150" cy="112" r="20" fill="'+c+'"/><circle cx="150" cy="112" r="20" '+S+' stroke-width="1.6"/>'
        + '<path d="M66 176 q26-20 52-4 t56 2" '+S+' stroke-width="1.6"/>'
        + '<path d="M66 202 q30-16 56 0 t52-2" '+S+' stroke-width="1.6"/>'
        + '<line x1="40" y1="256" x2="200" y2="256" '+S+'/>',
      // card slipping out of an envelope
      envelope: '<rect x="40" y="104" width="160" height="112" rx="5" fill="#FFF" '+S+'/>'
        + '<path d="M40 110 L120 168 L200 110" '+S+' stroke-width="1.8"/>'
        + '<rect x="70" y="52" width="100" height="112" rx="4" fill="'+c+'" opacity=".55"/>'
        + '<rect x="70" y="52" width="100" height="112" rx="4" fill="none" '+S+'/>'
        + '<g font-family="Space Mono, monospace" font-size="9" fill="var(--ink)"><text x="84" y="78">I SURVIVED</text></g>'
        + '<line x1="84" y1="88" x2="156" y2="88" '+S+' stroke-width="1.4"/>'
        + '<circle cx="120" cy="122" r="18" fill="'+c+'"/><circle cx="120" cy="122" r="18" '+S+' stroke-width="1.5"/>'
        + '<path d="M120 104 v36 M102 122 h36" '+S+' stroke-width="1.2"/>'
        + '<line x1="52" y1="248" x2="188" y2="248" '+S+'/>',
      // notebook open flat with two pens
      desk: '<rect x="34" y="86" width="172" height="120" rx="6" fill="#FFF" '+S+'/>'
        + '<line x1="120" y1="86" x2="120" y2="206" '+S+'/>'
        + '<rect x="46" y="100" width="60" height="92" fill="'+c+'" opacity=".55"/>'
        + '<circle cx="76" cy="132" r="15" '+S+' stroke-width="1.5"/>'
        + '<path d="M46 168 q16-12 30-2 t30 0" '+S+' stroke-width="1.4"/>'
        + '<g '+S+' stroke-width="1.4">'
        + [0,1,2,3,4].map(i=>'<line x1="134" y1="'+(112+i*18)+'" x2="192" y2="'+(112+i*18)+'"/>').join('')
        + '</g>'
        + '<rect x="60" y="228" width="92" height="9" rx="4.5" fill="'+c+'" '+S+' stroke-width="1.8"/>'
        + '<rect x="96" y="246" width="92" height="9" rx="4.5" fill="#FFF" '+S+' stroke-width="1.8"/>',
      // poster rolled with a ribbon
      tube: '<rect x="86" y="74" width="68" height="176" rx="8" fill="'+c+'" opacity=".45"/>'
        + '<rect x="86" y="74" width="68" height="176" rx="8" '+S+'/>'
        + '<path d="M86 96 h68 M86 228 h68" '+S+' stroke-width="1.6"/>'
        + '<path d="M96 74 v-24 q0-10 12-10 h24 q12 0 12 10 v24" fill="#FFF" '+S+'/>'
        + '<ellipse cx="120" cy="40" rx="12" ry="5" fill="'+c+'" '+S+' stroke-width="1.8"/>'
        + '<path d="M74 162 h92" '+S+' stroke-width="7" stroke-linecap="round"/>'
        + '<path d="M120 162 l-20-18 M120 162 l20-18" '+S+' stroke-width="3.2" stroke-linecap="round"/>'
        + '<line x1="44" y1="272" x2="196" y2="272" '+S+'/>',
      // a small stack, tied
      stack: '<rect x="44" y="128" width="152" height="46" rx="6" fill="'+c+'" opacity=".5" '+S+'/>'
        + '<rect x="56" y="92" width="128" height="42" rx="6" fill="#FFF" '+S+'/>'
        + '<rect x="68" y="58" width="104" height="38" rx="6" fill="'+c+'" opacity=".7" '+S+'/>'
        + '<path d="M120 52 v128" '+S+' stroke-width="4"/>'
        + '<path d="M120 56 q-18-18 -30-6 q-8 10 30 10 q38 0 30-10 q-12-12 -30 6z" fill="#FFF" '+S+' stroke-width="1.8"/>'
        + '<line x1="52" y1="212" x2="188" y2="212" '+S+'/>'
    }[kind];
    return '<svg viewBox="0 0 240 320" role="img" aria-label="Gift idea">'+bg+art+'</svg>';
  }


  function paintGifts(){
    document.querySelectorAll(".giftcard[data-kind]").forEach(function(card){
      var art = card.querySelector(".giftart");
      if (!art || art.dataset.painted) return;
      var tint = card.dataset.tint || "lilac";
      if (!TINTS[tint]) tint = "lilac";
      art.innerHTML = giftScene(card.dataset.kind, tint);
      art.dataset.painted = "1";
    });
    if (window.scanReveals) window.scanReveals();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", paintGifts);
  else paintGifts();
  document.addEventListener("shopify:section:load", paintGifts);
})();
